import React from "react";
import { Helmet } from "react-helmet-async";
import { ANNUAL_RETURNS, CIN_NUMBER } from "./constants";
import "./index.css";

function CompanyAnnualReport() {
  return (
    <div className="addressDetails car">
      {/* The page is served from both /investor-relations and the older
          /companyAnnualReport, so pin the canonical to the new one. */}
      <Helmet>
        <link
          rel="canonical"
          href="https://www.nowpurchase.com/investor-relations"
        />
      </Helmet>
      <div className="container">
        <div className="addressRow">
          <h2 className="titleText aosAnim boldText">Investor Relations</h2>

          <section className="irSection">
            {/* CIN sits with the section heading, right-aligned to the same
                edge as the buttons below it. */}
            <div className="irSectionHeader">
              <h3 className="irSectionTitle">Annual Returns</h3>
              <span className="cinNumber">CIN : {CIN_NUMBER}</span>
            </div>
            <div className="addressBoxWrap aosAnim">
              {ANNUAL_RETURNS.map(({ year, label, href, id }, index) => (
                <div className="eachAddressBox" key={year}>
                  <div>
                    <h4>
                      {index + 1}. Annual Return Financial Year {year}
                    </h4>
                  </div>
                  <div className="btnBox">
                    <a
                      href={href}
                      className="npButton"
                      target="_blank"
                      rel="noreferrer"
                      id={id}
                    >
                      {label}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <p className="contactQueryText">
            For any Queries, contact
            <span className="contactName"> Prateek Losalka </span>
            at <a href="tel:+916292137487" className="phone">+91 6292 137 487</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default CompanyAnnualReport;
